<template>
  <labeled-form-control label="Neutered">
    <div class="col">
      <div class="row">
        <div class="d-flex">
          <input v-model="neuteredId" :value="1" type="radio"/><span class="ml-2">Unknown</span>
        </div>
        <div class="ml-4 d-flex">
          <input v-model="neuteredId" :value="2" type="radio"/><span class="ml-2">Yes</span>
        </div>
        <div class="ml-4 d-flex">
          <input v-model="neuteredId" :value="3" type="radio"/><span class="ml-2">No</span>
        </div>
      </div>
    </div>
  </labeled-form-control>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'PetNeutered',
  props: {
    petId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'findPet'
    ]),
    pet () {
      return this.findPet(this.petId)
    },
    neuteredId: {
      get () {
        return this.pet.neuteredId
      },
      set (value) {
        this.updateNeuteredId({ petId: this.petId, value })
      }
    }
  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'updateNeuteredId'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
